export function getCurrentTimeForTimezone(timezoneId: string, date = new Date()) {
  return new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: timezoneId,
  })
    .format(date)
    .toLowerCase()
    .replace(/\s/g, "");
}

export function formatMultipleTimezones(
  timezoneIds: string[],
  timezoneLabels: string[] = [],
  date = new Date(),
) {
  return timezoneIds
    .map((timezoneId, index) => {
      const label = timezoneLabels[index] ?? timezoneId;
      return `${label}: ${getCurrentTimeForTimezone(timezoneId, date)}`;
    })
    .join(" / ");
}
